__turbopack_context__.v({
  "checkboxGroupHeading": "checkbox-group-heading-module-scss-module__wE6MQW__checkboxGroupHeading",
  "checkboxGroups": "checkbox-group-heading-module-scss-module__wE6MQW__checkboxGroups",
  "filterCount": "checkbox-group-heading-module-scss-module__wE6MQW__filterCount",
  "standalone": "checkbox-group-heading-module-scss-module__wE6MQW__standalone",
});
